import { StripeAccount } from '../models/stripe'

export const mockStripeAccounts = [
  { id: 1, name: 'SWTCH Test Account', country: 'CA' },
  { id: 2, name: 'SWTCH Test Account2', country: 'US' },
] as StripeAccount[]
